import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";

const ReviewCard = ({ name, stayDuration, rating, date, comment, photos }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="w-full font-hk  flex  mt-5  rounded-lg  overflow-hidden">
      <div className="flex-shrink-0 lg:my-4 lg:ml-6 my-6 mx-2">
        <img
          className="h-16 w-16 rounded-full"
          src="https://i.pinimg.com/736x/f4/8b/f6/f48bf61d42e7f7001773d00030e15d08.jpg"
          alt="Logo"
        />
      </div>
      <div className="lg:pr-6 pr-4 w-[100%] ">
        <div className="flex items-center justify-between  flex-row my-4">
          <div className="flex flex-row">
            <div className="">
              <h2 className="text-lg font-semibold text-gray-800">{name}</h2>
              <p className="text-sm  text-gray-600">{date}</p>
            </div>
            <p className="ml-3 text-sm mt-1 text-gray-600">{stayDuration}</p>
          </div>
          <div className="">
            <p className="text-[16px]  bg-black text-white p-1 rounded  flex-shrink-0">
              {rating}/10
            </p>
          </div>
        </div>
        <div className=" py-2">
          <p className="text-gray-700 text-base leading-6 mt-2">{comment}</p>
          <div className="flex flex-wrap flex-row mt-4">
            {photos.map((photo, index) => (
              <div key={index} className="relative">
                <img
                  className="object-cover h-24 w-36 ml-4 mb-2 lg:mb-0 rounded-sm"
                  src={photo.src}
                  alt="Photo"
                />
                {index === photos.length - 1 && (
                  <div className="absolute ml-4 mb-2 lg:mb-0 inset-0 flex items-center justify-center">
                    <button
                      onClick={() => setOpen(true)}
                      className="bg-black bg-opacity-50 text-white px-4 py-2 h-24 w-full rounded-sm"
                    >
                      <span className="opacity-100">View All</span>
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={photos}
        plugins={[Thumbnails]}
      />
    </div>
  );
};

export default ReviewCard;
